/* Dracula Edition gallery (snippets/lettoria-edition-gallery.liquid): the track swipes natively (scroll-snap);
 * this only keeps the counter, thumb rail and arrows in sync with the scroll position, and handles arrow keys.
 * No dependencies. Ported from Afroyla's set gallery. */
(function () {
  'use strict';

  function init(root) {
    var track = root.querySelector('[data-ltr-egal-track]');
    if (!track) return;
    var panes = track.querySelectorAll('[data-ltr-egal-pane]');
    var thumbs = root.querySelectorAll('[data-ltr-egal-thumb]');
    var count = root.querySelector('[data-ltr-egal-count]');
    var prev = root.querySelector('[data-ltr-egal-prev]');
    var next = root.querySelector('[data-ltr-egal-next]');
    var total = panes.length;
    if (total < 2) return;
    var current = 0;
    var ticking = false;

    function paint(i) {
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + total;
      for (var t = 0; t < thumbs.length; t += 1) {
        var on = t === i;
        thumbs[t].classList.toggle('is-active', on);
        thumbs[t].setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { var rail = thumbs[t].parentElement; if (rail) { var isRow = rail.scrollWidth > rail.clientWidth + 2; if (isRow) rail.scrollTo({ left: thumbs[t].offsetLeft - 8, behavior: 'smooth' }); else if (rail.scrollHeight > rail.clientHeight + 2) rail.scrollTo({ top: thumbs[t].offsetTop - 8, behavior: 'smooth' }); } }
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
    }

    function goTo(i) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: panes[i].offsetLeft, behavior: 'smooth' });
      paint(i);
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) paint(Math.max(0, Math.min(total - 1, i)));
      });
    }, { passive: true });

    for (var t = 0; t < thumbs.length; t += 1) {
      (function (idx) { thumbs[idx].addEventListener('click', function () { goTo(idx); }); })(t);
    }
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    /* browser restore (bfcache / back): snap the counter to wherever the track actually is */
    window.addEventListener('pageshow', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      paint(Math.max(0, Math.min(total - 1, i)));
    });
    paint(0);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ltr-egal]');
    for (var i = 0; i < roots.length; i += 1) {
      if (roots[i].__ltrEgal) continue; // already wired (re-boot after a section re-render must not double-bind)
      roots[i].__ltrEgal = true;
      init(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
